import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import classNames from "classnames";
import {
  apiRequest,
  showAlert,
  showLoading,
  API_SERVER_URL,
  getTeamUUID,
  getPlayerCode,
  getSessionUUID,
  TEAM_COLORS,
  formatPlayerNo,
  getEnergyHubPeopleNumText,
} from "../../utils";
import Alert from "../../components/Alert/Alert";

import ss from "./game.module.css";

export const GuidePage = () => {
  const navigate = useNavigate();
  const [teamInfo, setTeamInfo] = useState(null);
  // 任务列表
  const [taskList, setTaskList] = useState([]);
  // 底部任务类型选择，1 - 任务， 2 - 抢夺， 3 - 能量站
  const [taskTypeSelected, setTaskTypeSelected] = useState(1);
  // 抢夺列表
  const [robList, setRobList] = useState([]);
  const firstRobRef = useRef(null);
  // 抢夺日志列表
  const [robLogList, setRobLogList] = useState([]);
  // 所有队伍抢夺CD倒计时
  const [robCooldownMap, setRobCooldownMap] = useState({});
  // 抢夺倒计时
  const robCountdownRef = useRef(null);
  // 能量站列表
  const [hubList, setHubList] = useState([]);
  const firstHubRef = useRef(null);
  // 判定中的能量站
  const [hubJudgingList, setHubJudgingList] = useState([]);
  // 能量站日志列表
  const [hubLogList, setHubLogList] = useState([]);
  // 展示能量站弹层
  const [showHubInfo, setShowHubInfo] = useState(false);
  const [hubInfoClosing, setHubInfoClosing] = useState(false);
  // 当前能量站ref
  const currentHubRef = useRef(null);
  // 队伍中心弹层
  const [showTeamCenter, setShowTeamCenter] = useState(false);
  const [teamCenterClosing, setTeamCenterClosing] = useState(false);
  // 队伍中心信息
  const [teamCenterInfo, setTeamCenterInfo] = useState({});
  // 剩余时间倒计时
  const [remainTimeCountdown, setRemainTimeCountdown] = useState(0);
  // 场次地图信息
  const [sessionMap, setSessionMap] = useState({});
  // 当前讲解解锁的等级
  const [currentLevels, setCurrentLevels] = useState([]);
  // 1 级：当前是否任务判定
  const isTaskJudgedRef = useRef(false);
  // 3 级：当前是否能量站判定
  const [isHubJudged, setIsHubJudged] = useState(false);
  // 是否已经获取讲解状态
  const [isGuideStatusFetched, setIsGuideStatusFetched] = useState(false);
  // 场次补给
  const [sessionSupply, setSessionSupply] = useState(null);
  const [showSupplyModal, setShowSupplyModal] = useState(false);
  const [supplyModalClosing, setSupplyModalClosing] = useState(false);

  const getSessionMap = async () => {
    apiRequest("/get_session_map", "GET", { sid: getSessionUUID() })
      .then((res) => {
        if (res.code === 0) setSessionMap(res.map);
      })
      .catch((err) => {
        console.error("获取地图失败", err);
        showAlert("网络异常，请刷新重试");
      });
  };

  const getTeamInfo = async (callback) => {
    // const loading = skipLoading ? null : showLoading("加载中");
    apiRequest("/get_player_team_info", "GET", {
      tid: getTeamUUID(),
      code: getPlayerCode(),
    }).then((res) => {
      if (res.code === 0) {
        setTeamInfo(res.data);
        setRemainTimeCountdown(res.data.remain_time);
        callback?.();
      } else showAlert(res.msg);
    });
    // .finally(() => !skipLoading && loading?.hide());
  };

  const getTaskList = async () => {
    if (isTaskJudgedRef.current) {
      setTaskList([
        {
          id: 244,
          team_id: 23,
          team_color: "1",
          task_id: 66,
          type: 2,
          reward: 200,
          desc: "找到一只【长着翅膀的粉色飞猪】",
          position: "区域B",
          status: 0,
          submit_time: null,
          photo: null,
          failed_reason: null,
          failed_reason_desc: "",
        },
        {
          id: 1,
          team_id: 23,
          team_color: "1",
          task_id: 66,
          type: 2,
          reward: 150,
          desc: "找到一位【戴着帽子的路人】",
          position: "全场",
          status: 1,
          submit_time: null,
          photo: null,
          failed_reason: null,
          failed_reason_desc: "",
        },
        {
          id: 232,
          team_id: 23,
          team_color: "1",
          task_id: 5,
          type: 1,
          reward: 100,
          desc: "拍一张【和队友一起扮鬼脸】的照片",
          position: "全场",
          status: 2,
          submit_time: "2025-04-18T16:44:25.528700+00:00",
          failed_reason: null,
          failed_reason_desc: "",
        },
        {
          id: 228,
          team_id: 23,
          team_color: "1",
          task_id: 132,
          type: 4,
          reward: 150,
          desc: "找到一个包含【英文字母A】的物品",
          position: "全场",
          status: 3,
          submit_time: "2025-04-18T16:15:40.564493+00:00",
          failed_reason: null,
          failed_reason_desc: "对象错误",
        },
      ]);
    } else {
      setTaskList([
        {
          id: 244,
          team_id: 23,
          team_color: "1",
          task_id: 66,
          type: 2,
          reward: 200,
          desc: "找到一只【长着翅膀的粉色飞猪】",
          position: "区域B",
          status: 0,
          submit_time: null,
          failed_reason: null,
          failed_reason_desc: "",
        },
      ]);
    }
  };

  const renderRobJudge = () => {
    // 抢夺判定及冷却
    // setRobCooldownMap({ [firstRobRef.current.uuid]: 60 });
    setRobLogList([
      {
        id: 273,
        status: 1,
        rob_team_id: 24,
        rob_team_uuid: firstRobRef.current.uuid,
        rob_team_name: firstRobRef.current.name,
        rob_energy: 300,
        failed_reason: null,
        failed_reason_desc: "",
      },
      {
        id: 264,
        status: 2,
        rob_team_id: 23,
        rob_team_uuid: firstRobRef.current.uuid,
        rob_team_name: firstRobRef.current.name,
        rob_energy: 300,
        failed_reason: null,
        failed_reason_desc: "",
      },
      {
        id: 263,
        status: 3,
        rob_team_id: 24,
        rob_team_uuid: firstRobRef.current.uuid,
        rob_team_name: firstRobRef.current.name,
        rob_energy: 300,
        failed_reason: null,
        failed_reason_desc: "照片不清晰",
      },
      {
        id: 261,
        status: 2,
        rob_team_id: 24,
        rob_team_uuid: getTeamUUID(),
        rob_team_name: teamInfo?.name,
        rob_energy: 300,
        failed_reason: null,
        failed_reason_desc: "",
      },
    ]);
  };

  const renderHubJudge = () => {
    setIsHubJudged(true);
    setHubLogList([
      {
        time: "2025-04-21T15:47:21.889Z",
        desc: `【${firstHubRef.current.energy_hub_name}】占领成功`,
        value: "正在累积奖励",
        type: 1,
      },
      {
        time: "2025-04-20T09:45:04.847Z",
        desc: `【${firstHubRef.current.energy_hub_name}】判定失败`,
        value: "人数错误",
        type: 3,
      },
    ]);
  };

  const renderSupplyJudge = () => {
    setSessionSupply({
      id: 24,
      type: "任务补给",
      target_team_color: teamInfo?.color,
      target_team_name: teamInfo?.name,
      target_team_uuid: getTeamUUID(),
      desc: "与对方任意成员合影",
      reward: "共享/抢夺（2选1）",
      status: 0,
    });
  };

  const getGuideStatus = async () => {
    const loading = showLoading("加载中");
    apiRequest("/get_guide_status", "GET", { sid: getSessionUUID() })
      .then((res) => {
        if (res.code === 0) {
          const enabledLevels = [];
          Object.keys(res.guide_status).forEach((item) => {
            if (item.startsWith("level")) {
              const level = item.split("level")[1];
              enabledLevels.push(parseInt(level));
            } else if (item === "judge1") {
              isTaskJudgedRef.current = true;
              getTaskList();
            } else if (item === "judge2") {
              renderRobJudge();
            } else if (item === "judge3") {
              renderHubJudge();
            } else if (item === "judge11") {
              renderSupplyJudge();
            }
          });
          setCurrentLevels(enabledLevels);
          getTaskList();
          setIsGuideStatusFetched(true);
        } else showAlert(res.msg);
      })
      .finally(() => loading?.hide());
  };

  const getRobList = async (skipLoading, callback) => {
    const loading = skipLoading ? null : showLoading("加载中");
    apiRequest("/get_rob_list", "GET", {
      sid: getSessionUUID(),
      tid: getTeamUUID(),
      code: getPlayerCode(),
    })
      .then((res) => {
        if (res.code === 0) {
          setRobList(res.rob_teams);
          firstRobRef.current = res.rob_teams[0];
          callback?.();
          // const robCooldownMap = {};
          // res.rob_teams.forEach((rob) => {
          //   robCooldownMap[rob.uuid] = rob.cooldown;
          // });
          // setRobCooldownMap(robCooldownMap);
          // setRobLogList(res.player_rob_list);
        } else showAlert(res.msg);
      })
      .finally(() => !skipLoading && loading?.hide());
  };

  const getHubList = async (skipLoading, callback) => {
    const loading = skipLoading ? null : showLoading("加载中");
    apiRequest("/get_energy_hub_list", "GET", {
      sid: getSessionUUID(),
      tid: getTeamUUID(),
      code: getPlayerCode(),
    })
      .then((res) => {
        if (res.code === 0) {
          setHubList(res.energy_hubs);
          firstHubRef.current = res.energy_hubs[0];
          callback?.();
          // setHubJudgingList(res.energy_hubs_player_photos);
          // setHubLogList(res.team_energy_hub_logs);
        } else showAlert(res.msg);
      })
      .finally(() => !skipLoading && loading?.hide());
  };

  const getTeamCenterInfo = async () => {
    // const loading = showLoading("加载中");
    apiRequest("/team_center_info", "GET", {
      tid: getTeamUUID(),
    }).then((res) => {
      if (res.code === 0) setTeamCenterInfo(res.data);
      else showAlert(res.msg);
    });
    // .finally(() => loading.hide());
  };

  useEffect(() => {
    if (Object.values(robCooldownMap).every((cooldown) => cooldown <= 0)) {
      clearInterval(robCountdownRef.current);
      return;
    }
    robCountdownRef.current = setTimeout(() => {
      setRobCooldownMap((prev) => {
        const newMap = { ...prev };
        Object.keys(prev).forEach((key) => {
          newMap[key]--;
        });
        return newMap;
      });
    }, 1000);
    return () => clearTimeout(robCountdownRef.current);
  }, [robCooldownMap]);

  useEffect(() => {
    getSessionMap();
    getTeamInfo();
    getRobList(true, () => {
      getHubList(true, () => getGuideStatus());
    });
  }, []);

  useEffect(() => {
    if (!teamInfo?.session_uuid) return;

    if (teamInfo?.actived) {
      // 如果激活了，获取任务列表
      getTaskList();
    }

    // 建立SSE连接
    let eventSource = new EventSource(
      `${API_SERVER_URL}/subscribe_messages?device_id=${teamInfo.session_uuid}`
    );
    // 监听消息
    const onMessage = (event) => {
      const message = JSON.parse(event.data);
      console.log("收到消息:", message);
      // 处理连接成功消息
      if (message.type === "connected") {
        console.log("SSE连接成功");
        return;
      } else if (message.type === "start_guide_level") {
        let delay = 0;
        if (message.level > 1 && message.level <= 3) {
          Alert.show({
            type: "alert",
            title: "队伍升级",
            message: `等级升为${message.level}级，已解锁新的功能`,
          });
          delay = 500;
        }
        // 这里需要再取一下抢夺列表，因为玩家加入之后可能其他队伍还没设置名称
        if (message.level === 2) getRobList(true);
        if (message.level <= 3) {
          setTimeout(() => {
            if (!currentLevels.includes(parseInt(message.level))) {
              setCurrentLevels([...currentLevels, parseInt(message.level)]);
            }
            setTaskTypeSelected(message.level);
          }, delay);
        }
        // 直接揭晓状态
        if (message.level === 1) {
          isTaskJudgedRef.current = true;
          getTaskList();
        } else if (message.level === 2) {
          renderRobJudge();
        } else if (message.level === 3) {
          renderHubJudge();
        } else if (message.level === 11) {
          renderSupplyJudge();
        }
      } else if (message.type === "start_guide_judge") {
        // 已废弃
        if (message.level === 1) {
          isTaskJudgedRef.current = true;
          getTaskList();
        } else if (message.level === 2) {
          renderRobJudge();
        } else if (message.level === 3) {
          renderHubJudge();
        }
      } else if (message.type === "guide_open_hub") {
        // 已废弃
        if (message.open === 1) {
          // 打开能量站浮层
          currentHubRef.current = firstHubRef.current;
          setShowHubInfo(true);
        } else {
          // 关闭能量站浮层
          closeHubInfo();
        }
      } else if (message.type === "guide_back_map") {
        navigate("/game", { replace: true });
      }
    };
    // 连接建立时的回调
    eventSource.onopen = () => {
      console.log("SSE连接已建立");
    };
    eventSource.onmessage = onMessage;
    // 错误处理
    eventSource.onerror = (error) => {
      console.error("SSE错误:", error);
      eventSource.close();

      // 3s后尝试重连
      setTimeout(() => {
        // Create a new EventSource connection
        eventSource = new EventSource(
          `${API_SERVER_URL}/subscribe_messages?device_id=${teamInfo.session_uuid}`
        );
        // Re-attach event handlers
        eventSource.onmessage = onMessage;
      }, 3000);
    };
    // 在组件卸载时关闭连接
    return () => {
      if (eventSource) {
        eventSource.close();
        eventSource = null;
      }
    };
  }, [teamInfo?.session_uuid, teamInfo?.actived, currentLevels]);

  const closeHubInfo = () => {
    setHubInfoClosing(true);
    setTimeout(() => {
      setShowHubInfo(false);
      setHubInfoClosing(false);
    }, 600);
  };

  const closeTeamCenter = () => {
    setTeamCenterClosing(true);
    setTimeout(() => {
      setShowTeamCenter(false);
      setTeamCenterClosing(false);
    }, 600);
  };

  const closeSupplyModal = () => {
    setSupplyModalClosing(true);
    setTimeout(() => {
      setShowSupplyModal(false);
      setSupplyModalClosing(false);
    }, 600);
  };

  if (!teamInfo) return null;

  return (
    <div className={ss.gameContainer}>
      <div className={ss.preload}>
        <img src={require("./imgs/supply_bg_hl.png")} alt="supplyBoxDown" />
      </div>
      <div className={ss.teamCard}>
        <div className={ss.teamHeader}>
          <div className={ss.teamName}>
            <img
              className={ss.teamIcon}
              src={require(`../../imgs/team/color${teamInfo.color}.png`)}
              alt=""
              onClick={() => window.location.reload()}
            />
            <h2 className={ss.teamTitle}>{teamInfo.name}</h2>
            <div
              className={ss.playerNo}
              style={{ color: TEAM_COLORS[teamInfo.color] }}
            >
              {formatPlayerNo(teamInfo.player_no)}
            </div>
          </div>
          <div
            className={classNames(ss.teamCenterButton)}
            onClick={() => {
              getTeamCenterInfo();
              setShowTeamCenter(true);
            }}
          >
            队伍中心
          </div>

          <div className={ss.teamInfo}>
            <div className={ss.infoItem}>
              <div className={ss.infoLabel}>顽皮能量值</div>
              <div className={ss.infoValue}>
                {teamInfo.game_status === 200 ? "????" : teamInfo.energy}
              </div>
            </div>
            <div className={ss.infoItem}>
              <div className={ss.infoLabel}>当前等级</div>
              <div className={ss.stars}>
                <span className={ss.star}>
                  {currentLevels.includes(1) && teamInfo.actived ? "★" : "☆"}
                </span>
                <span className={ss.star}>
                  {currentLevels.includes(2) && teamInfo.actived ? "★" : "☆"}
                </span>
                <span className={ss.star}>
                  {currentLevels.includes(3) && teamInfo.actived ? "★" : "☆"}
                </span>
              </div>
            </div>
            <div className={ss.infoItem}>
              <div className={ss.infoLabel}>剩余时间</div>
              <div className={ss.infoValue}>
                {teamInfo.game_status === 0 && "??"}
                {teamInfo.game_status === 50 && "0"}
                {teamInfo.game_status === 100 &&
                  Math.ceil(remainTimeCountdown / 60)}
                {teamInfo.game_status >= 200 && "0"}
              </div>
            </div>
          </div>
        </div>

        <div className={classNames(ss.contentBox)}>
          {isGuideStatusFetched && currentLevels.length === 0 && (
            <div className={ss.map}>
              <img
                src={
                  teamInfo.game_status === 200
                    ? sessionMap.map_photo
                    : sessionMap.inactive_photo
                }
              />
            </div>
          )}

          {currentLevels.length > 0 && (
            <>
              {taskTypeSelected === 1 && (
                <div className={ss.taskList}>
                  {taskList.map((task) => (
                    <div
                      className={classNames(
                        ss.taskCard,
                        task.status > 0 && ss.disabled
                      )}
                      key={task.id}
                    >
                      <div className={ss.label}>任务说明：</div>
                      <div className={ss.desc}>{task.desc}</div>
                      <div className={ss.taskFooter}>
                        {task.status === 1 && (
                          <div className={ss.taskFooterTxt}>
                            任务已提交，正在判定中…
                          </div>
                        )}
                        {task.status === 2 && (
                          <div className={ss.taskFooterTxt}>
                            任务成功 +{task.reward}
                          </div>
                        )}
                        {task.status === 3 && (
                          <div
                            className={classNames(ss.taskFooterTxt, ss.failed)}
                          >
                            <span>判定失败：{task.failed_reason_desc}</span>
                          </div>
                        )}
                        {task.status === 0 && (
                          <>
                            <div
                              className={classNames(ss.changeBtn)}
                              style={{ pointerEvents: "none" }}
                            >
                              更换
                            </div>
                            <div
                              className={ss.actionBtn}
                              style={{ pointerEvents: "none" }}
                            >
                              <div className={ss.actionBtnText}>完成任务</div>
                            </div>
                          </>
                        )}
                      </div>
                      <div
                        className={classNames(
                          ss.reward,
                          task.status > 0 && ss.gray
                        )}
                      >
                        奖励：+{task.reward}点
                      </div>
                      <div
                        className={classNames(
                          ss.position,
                          task.status > 0 && ss.gray
                        )}
                      >
                        位置：{task.position}
                      </div>
                    </div>
                  ))}
                </div>
              )}
              {taskTypeSelected === 2 && (
                <>
                  <div className={ss.robList}>
                    {robList.map((rob) => (
                      <div
                        className={classNames(
                          ss.robItem,
                          robCooldownMap[rob.uuid] > 0 && ss.cd
                        )}
                        key={rob.uuid}
                        style={{
                          backgroundImage: `url(${
                            robCooldownMap[rob.uuid] > 0
                              ? require(`./imgs/rob_team_bg_gray.png`)
                              : require(`../../imgs/team/bg${rob.color}.png`)
                          })`,
                          backgroundSize: "100% 100%",
                          backgroundRepeat: "no-repeat",
                          color:
                            robCooldownMap[rob.uuid] > 0
                              ? "#a5a5a5"
                              : TEAM_COLORS[rob.color],
                          pointerEvents: "none",
                        }}
                      >
                        <div
                          className={ss.robItemIcon}
                          style={{
                            backgroundImage: `url(${
                              robCooldownMap[rob.uuid] > 0
                                ? require(`../../imgs/team_color_gray.png`)
                                : require(`../../imgs/team/color${rob.color}.png`)
                            })`,
                            backgroundSize: "100% 100%",
                            backgroundRepeat: "no-repeat",
                          }}
                        ></div>
                        <div className={ss.robItemName}>{rob.name}</div>
                        {robCooldownMap[rob.uuid] > 0 && (
                          <div className={ss.robItemCountdown}>
                            {robCooldownMap[rob.uuid]}
                            <span>s</span>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                  <div className={ss.robLogList}>
                    {robLogList.map((robLog) => (
                      <div
                        key={robLog.id}
                        className={classNames(
                          ss.robLogItem,
                          robLog.rob_team_uuid !== getTeamUUID() &&
                            robLog.status === 1 &&
                            ss.pending
                        )}
                      >
                        {robLog.rob_team_uuid === getTeamUUID() &&
                          robLog.status === 2 && (
                            <>
                              <div className={ss.robLogItemLabel}>被抢夺</div>
                              <div
                                className={classNames(
                                  ss.robLogItemValue,
                                  ss.robbed
                                )}
                              >
                                -{robLog.rob_energy}
                              </div>
                            </>
                          )}
                        {robLog.rob_team_uuid !== getTeamUUID() && (
                          <>
                            {robLog.status === 1 && (
                              <>
                                <div
                                  className={classNames(
                                    ss.robLogItemLabel,
                                    ss.pending
                                  )}
                                >
                                  抢夺【{robLog.rob_team_name}】已提交
                                </div>
                                <div
                                  className={classNames(
                                    ss.robLogItemValue,
                                    ss.pending
                                  )}
                                >
                                  正在判定中
                                </div>
                              </>
                            )}
                            {robLog.status === 2 && (
                              <>
                                <div className={ss.robLogItemLabel}>
                                  抢夺【{robLog.rob_team_name}】成功
                                </div>
                                <div
                                  className={classNames(
                                    ss.robLogItemValue,
                                    ss.success
                                  )}
                                >
                                  +{robLog.rob_energy}
                                </div>
                              </>
                            )}
                            {robLog.status === 3 && (
                              <>
                                <div className={ss.robLogItemLabel}>
                                  抢夺【{robLog.rob_team_name}】失败
                                </div>
                                <div
                                  className={classNames(
                                    ss.robLogItemValue,
                                    ss.failed
                                  )}
                                >
                                  {robLog.failed_reason_desc}
                                </div>
                              </>
                            )}
                          </>
                        )}
                      </div>
                    ))}
                  </div>
                </>
              )}
              {taskTypeSelected === 3 && (
                <>
                  <div className={ss.hubList}>
                    {hubList.map((hub, index) => {
                      // 自己判定中的能量站
                      const isSelfJudging = hubJudgingList.find(
                        (item) =>
                          item.energy_hub_id === hub.energy_hub_id &&
                          item.team_uuid === getTeamUUID()
                      );
                      // 其他队伍判定中的能量站
                      const isOtherJudging = hubJudgingList.find(
                        (item) =>
                          item.energy_hub_id === hub.energy_hub_id &&
                          item.team_uuid !== getTeamUUID()
                      );
                      // 自己已占领的能量站
                      // const isSelfOccupied = hubList.find(
                      //   (item) =>
                      //     item.energy_hub_id === hub.energy_hub_id &&
                      //     item.current_team_uuid === getTeamUUID()
                      // );
                      const isSelfOccupied = index === 0 && isHubJudged;
                      // 其他队伍已占领的能量站
                      const isOtherOccupied = hubList.find(
                        (item) =>
                          item.energy_hub_id === hub.energy_hub_id &&
                          item.current_team_uuid &&
                          item.current_team_uuid !== getTeamUUID()
                      );
                      return (
                        <div
                          className={classNames(
                            ss.hubItem,
                            (isSelfJudging || isOtherJudging) &&
                              !isSelfOccupied &&
                              ss.cd
                          )}
                          onClick={() => {
                            currentHubRef.current = hub;
                            setShowHubInfo(true);
                          }}
                        >
                          {!isOtherJudging && !isSelfOccupied && (
                            <>
                              <div className={ss.hubItemName}>
                                {hub.energy_hub_name}
                              </div>
                              {/* 未占领 */}
                              {!hub.current_team_id && (
                                <div className={ss.hubItemValue}>
                                  【+{hub.energy_rate}点】
                                </div>
                              )}
                            </>
                          )}

                          {/* 已被本队占领 */}
                          {isSelfOccupied && (
                            <>
                              <div
                                className={ss.flag}
                                style={{
                                  backgroundImage: `url(${require(`../../imgs/team/flag${teamInfo.color}.png`)})`,
                                }}
                              ></div>
                              <div className={ss.hubItemName}>
                                {hub.energy_hub_name}
                              </div>
                              <div className={ss.hubItemValue}>
                                【+{hub.energy_rate}点】
                              </div>
                              {/* <div className={ss.hubItemOccupied}>已占领</div> */}
                            </>
                          )}
                          {/* 已被其他队伍占领并且不在判定中 */}
                          {isOtherOccupied && !isOtherJudging && (
                            <>
                              <div
                                className={ss.flag}
                                style={{
                                  backgroundImage: `url(${require(`../../imgs/team/flag${hub.current_team_color}.png`)})`,
                                }}
                              ></div>
                              <div className={ss.hubItemValue}>
                                【+{hub.energy_rate}点】
                              </div>
                            </>
                          )}
                          {/* 自己判定中的能量站 */}
                          {isSelfJudging && (
                            <div className={ss.hubItemOccupied}>正在判定中</div>
                          )}
                          {/* 其他队伍判定中的能量站，且不是本队已占领 */}
                          {isOtherJudging &&
                            hub.current_team_uuid !== getTeamUUID() && (
                              <>
                                <div
                                  className={ss.flag}
                                  style={{
                                    backgroundImage: `url(${require(`../../imgs/flag_gray.png`)})`,
                                  }}
                                ></div>
                                <div className={ss.hubItemFrozen}>冻结中</div>
                              </>
                            )}
                        </div>
                      );
                    })}
                  </div>
                  <div className={ss.hubLogList}>
                    {hubLogList.map((log) => {
                      return (
                        <div className={ss.hubLogItem}>
                          <div className={ss.hubLogItemLabel}>{log.desc}</div>
                          <div
                            className={classNames(
                              ss.hubLogItemValue,
                              log.type === 2 && ss.success,
                              log.type === 3 && ss.robbed
                            )}
                          >
                            {log.value}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </>
              )}
            </>
          )}
        </div>
      </div>
      <div
        className={classNames(
          ss.teamFooter,
          teamInfo.game_status >= 300 && ss.hide
        )}
      >
        <>
          <div
            className={classNames(
              ss.taskBtn,
              taskTypeSelected === 1 && ss.selected,
              !currentLevels.includes(1) && ss.lock
            )}
            onClick={() => setTaskTypeSelected(1)}
          >
            任务
          </div>
          <div
            className={classNames(
              ss.taskBtn,
              taskTypeSelected === 2 && ss.selected,
              !currentLevels.includes(2) && ss.lock
            )}
            onClick={() => setTaskTypeSelected(2)}
          >
            抢夺
          </div>
          <div
            className={classNames(
              ss.taskBtn,
              taskTypeSelected === 3 && ss.selected,
              !currentLevels.includes(3) && ss.lock
            )}
            onClick={() => setTaskTypeSelected(3)}
          >
            能量站
          </div>
        </>
      </div>
      {/* 能量站弹层 */}
      {showHubInfo && (
        <div className={classNames(ss.hubMask, hubInfoClosing && ss.fadeOut)}>
          <div
            className={classNames(ss.hubModal, hubInfoClosing && ss.zoomOut)}
          >
            <div className={ss.hubInfo}>
              <div className={ss.closeBtn} onClick={() => closeHubInfo()}></div>
              <div className={ss.hubName}>
                <span>{currentHubRef.current.energy_hub_name}</span>
              </div>
              <div className={ss.photoHint}>
                &lt; 请根据指定人数及动作进行合照 &gt;
              </div>
              <div className={ss.photoInfo}>
                <div className={ss.photoInfoItem}>
                  动作: {currentHubRef.current.photo_guide}
                </div>
                <div className={ss.photoInfoItem}>
                  人数:{" "}
                  {getEnergyHubPeopleNumText(currentHubRef.current.people_num)}
                </div>
              </div>
              <div className={ss.photoInfoFields}>
                <div className={ss.photoInfoField}>
                  站点位置：{currentHubRef.current.position}
                </div>
                <div className={ss.photoInfoField}>
                  占领奖励：+{currentHubRef.current.energy_rate}点
                </div>
              </div>
              <div className={ss.hubBtn} style={{ pointerEvents: "none" }}>
                占领能量站
              </div>
            </div>
          </div>
        </div>
      )}
      {/* 队伍中心弹层 */}
      {showTeamCenter && (
        <div
          className={classNames(ss.hubMask, teamCenterClosing && ss.fadeOut)}
        >
          <div
            className={classNames(
              ss.teamCenter,
              teamCenterClosing && ss.zoomOut
            )}
          >
            <div className={ss.teamCenterClose} onClick={closeTeamCenter}></div>
            <div className={ss.teamCenterTitle}>队伍中心</div>
            <div className={ss.teamCenterInfo}>
              <div className={ss.teamCenterInfoItem}>
                <div className={ss.teamCenterInfoLable}>任务成功</div>
                <div className={ss.teamCenterInfoValue}>
                  {teamCenterInfo.tasks_success}/次
                </div>
              </div>
              <div className={ss.teamCenterInfoItem}>
                <div className={ss.teamCenterInfoLable}>抢夺成功</div>
                <div className={ss.teamCenterInfoValue}>
                  {teamCenterInfo.rob_success}/次
                </div>
              </div>
              <div className={ss.teamCenterInfoItem}>
                <div className={ss.teamCenterInfoLable}>被抢夺</div>
                <div className={ss.teamCenterInfoValue}>
                  {teamCenterInfo.be_robbed_success}/次
                </div>
              </div>
              {/* <div className={ss.teamCenterInfoItem}>
                <div className={ss.teamCenterInfoLable}>占领成功</div>
                <div className={ss.teamCenterInfoValue}>
                  {teamCenterInfo.occupy_success}/次
                </div>
              </div> */}
              <div className={ss.teamCenterInfoItem}>
                <div className={ss.teamCenterInfoLable}>能量站收益</div>
                <div className={ss.teamCenterInfoValue}>
                  {teamCenterInfo.occupy_total_reward}/点
                </div>
              </div>
              <div className={ss.teamCenterInfoItem}>
                <div className={ss.teamCenterInfoLable}>补给收益</div>
                <div className={ss.teamCenterInfoValue}>
                  {teamCenterInfo.supply_total_reward}/点
                </div>
              </div>
              <div className={ss.teamCenterInfoItem}>
                <div className={ss.teamCenterInfoLable}>判定失败</div>
                <div className={classNames(ss.teamCenterInfoValue, ss.failed)}>
                  {teamCenterInfo.failed_energy}/点
                </div>
              </div>
            </div>
            <div className={ss.teamCenterMap}>
              <img src={sessionMap.tc_map} />
            </div>
          </div>
        </div>
      )}
      <div
        className={classNames(
          ss.supplyBox,
          sessionSupply && ss.show,
          sessionSupply?.status !== 0 && ss.gray,
          sessionSupply?.status === 1 && ss.disabled
        )}
        onClick={() => {
          // 从刷新恢复状态时不能保证获取到队伍信息，这里再生成一次数据
          renderSupplyJudge();
          setShowSupplyModal(true);
        }}
      >
        <div className={ss.supplyText}>{sessionSupply?.type}</div>
      </div>
      {/* 补给弹层 */}
      {showSupplyModal && (
        <div
          className={classNames(ss.hubMask, supplyModalClosing && ss.fadeOut)}
        >
          <div
            className={classNames(
              ss.supplyModal,
              supplyModalClosing && ss.zoomOut
            )}
          >
            <div className={ss.supplyInfo}>
              <div className={ss.supplyClose} onClick={closeSupplyModal}></div>
              <div className={ss.supplyType}>
                <span>{sessionSupply.type}</span>
              </div>
              <>
                <div className={ss.supplyHint}>
                  &lt; 率先完成的队伍可获得奖励 &gt;
                </div>
                <div className={ss.actionTip}>
                  <p>&lt; 共享：双方各得400点 &gt;</p>
                  <p>&lt; 抢夺：抢走对方800点 &gt;</p>
                </div>
                <div className={ss.supplyItemRow}>
                  <div className={ss.supplyItemRowLabel}>对象</div>
                  <div
                    className={ss.supplyItemRowTeamFlag}
                    style={
                      sessionSupply?.target_team_color && {
                        backgroundImage: `url(${require(`../../imgs/team/color${sessionSupply.target_team_color}.png`)})`,
                      }
                    }
                  />
                  <div
                    className={ss.supplyItemRowTeamName}
                    style={{
                      color: TEAM_COLORS[sessionSupply.target_team_color],
                    }}
                  >
                    {sessionSupply.target_team_name}
                  </div>
                </div>
                <div className={ss.supplyItemRow}>
                  <div className={ss.supplyItemRowLabel}>任务</div>
                  <span>{sessionSupply.desc}</span>
                </div>
                <div className={ss.supplyItemRow}>
                  <div className={ss.supplyItemRowLabel}>奖励</div>
                  <span>{sessionSupply.reward}</span>
                </div>
                <div className={ss.supplySelectHint}>
                  <span>&lt; 合影后可选择共享或抢夺 &gt;</span>
                </div>
                <div
                  className={ss.getSupplyBtn}
                  style={{ pointerEvents: "none" }}
                  onClick={() => takeSupplyPhoto(sessionSupply.id)}
                >
                  完成任务
                </div>
              </>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
